import { supabase } from "@/integrations/supabase/client";

/** Treat anything containing "@" as an email; otherwise it's a staff username. */
export const looksLikeEmail = (input: string): boolean => input.includes("@");

export type ResolveResult =
  | { kind: "email"; email: string }
  | { kind: "needsSalon" }
  | { kind: "notFound" };

/**
 * Turn a login identifier into an email usable with signInWithPassword.
 * - real email → passed straight through
 * - staff username → resolved via the staff-login-resolve edge function.
 *   When the username exists in several salons the function asks for the salon
 *   (kind: "needsSalon") WITHOUT revealing which salons — the user types theirs.
 */
export async function resolveStaffLoginEmail(
  identifier: string,
  salon?: string,
): Promise<ResolveResult> {
  const input = identifier.trim();
  if (looksLikeEmail(input)) return { kind: "email", email: input };

  const { data, error } = await supabase.functions.invoke("staff-login-resolve", {
    body: { username: input, ...(salon ? { salon_slug: salon } : {}) },
  });
  if (error || !data) return { kind: "notFound" };

  const d = data as {
    found?: boolean;
    email?: string | null;
    needsSalon?: boolean;
  };
  if (d.found && d.email) return { kind: "email", email: d.email };
  if (d.needsSalon) return { kind: "needsSalon" };
  return { kind: "notFound" };
}
